import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      titleFaq="자주 하는 질문"
      items={[
        {
          question: 'Mind the Graph支持何种付款方式？',
          answer: '针对中国用户，我们目前仅支持以支付宝付款。',
        },
        {
          question: '왜 그래픽 초록이 필요한가요?',
          answer:
            '年付会员是一次性结清全年订阅费；季付是按季度（3个月）订阅；月付是以月为单位进行订阅。 按年缴费者至多可省37%订阅费，近乎免除4个月费用。',
        },
        {
          question: '团队账号有哪些优势？',
          answer:
            '团队账号可满足精细化的定制需求，专为学术团体与业界团队而设。每个账户至多可容纳10人同时使用，相较每人持个人付费账号费用更低。团队用户间可共享内容，提升协作效率。此外，团队账号使用者还可获：优先客服支持、作图模板/PPT/团队标识等设计支持、成品图定制优惠、独家插画版权。',
        },
      ]}
    />
  );
}
